module.exports = __webpack_public_path__ + "static/img/unpaid-reservation.9ca76bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/unpaid-reservation.svg
// module id = 705
// module chunks = 37